import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { GraphQlQuery, IGraphQlQueryExecutor } from "../../../services/GraphQl/IGraphQL.service";



export function GraphQlQueryExecutor(graphQlQueryExecutor: Observable<IGraphQlQueryExecutor>): OperatorFunction<GraphQlQuery, GraphQlQueryResult> {

  return switchMap(query => {
    return graphQlQueryExecutor.pipe(
      switchMap(_graphQlQueryExecutor => {
        return _graphQlQueryExecutor.getGraphQlResults(query).pipe(
          map(result => {
            return {
              graphQlQuery: query,
              result: result
            };
          })
        );
      })
    );
  });
}


export interface GraphQlQueryResult {
  graphQlQuery: GraphQlQuery,
  result: any
}
